import isNil from 'lodash/isNil'
import pick from 'lodash/pick'

import { ParticipantType } from '@core/modules/briefings'
import { ParticipantRequestType } from '@core/react-query/features/briefing'

type ParticipantPartial = Pick<
  ParticipantType,
  'userId' | 'participantId' | 'sessionParticipantId' | 'roleId'
> & { localId?: string }

const checkNotNilAndEqual = (a: unknown, b: unknown) =>
  !isNil(a) && !isNil(b) && a === b

export const isSameParticipantsWithSameRole = (
  p1: ParticipantPartial,
  p2: ParticipantPartial,
) =>
  p1.roleId === p2.roleId &&
  (checkNotNilAndEqual(p1.participantId, p2.participantId) ||
    checkNotNilAndEqual(p1.sessionParticipantId, p2.sessionParticipantId) ||
    checkNotNilAndEqual(p1.userId, p2.userId) ||
    checkNotNilAndEqual(p1.localId, p2.localId))

// Function to omit fields that are not needed for the API
// and rename fields to match the payload format
export const transformParticipantsToPayloadFormat = (
  participants: ParticipantType[],
): ParticipantRequestType[] =>
  participants.map((participant) => ({
    ...pick<typeof participant, keyof typeof participant>(participant, [
      'participantId',
      'userId',
      'sessionParticipantId',
      'firstName',
      'lastName',
      'company',
      'signature',
    ]),
    briefOnRoleId: participant.roleId,
  }))

// Used for faster external user comparison/lookup
export const uniqKeyFromExternalUser = (
  user: Pick<ParticipantType, 'firstName' | 'lastName' | 'company'>,
) => `${user.firstName}_${user.lastName}_${user.company}`
